import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locale/en'
import de from '@/locale/de'
import ru from '@/locale/ru'
import es from '@/locale/es'
import fr from '@/locale/fr'
import it from '@/locale/it'
import hi from '@/locale/hi'
import mn from '@/locale/mn'
import zh from '@/locale/zh'
import vi from '@/locale/vi'
import ja from '@/locale/ja'
import ar from '@/locale/ar'
import pt from '@/locale/pt'
import ko from '@/locale/ko'

Vue.use(VueI18n)

const messages = {en, de, ru, es, fr, it, hi, mn, zh, vi, ja, ar, pt, ko}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
